import React, { PropTypes } from 'react';
import { imageServerUrl, alternateImageServerUrl } from './pic.settings.js';
import classSet from './classSet';

var OptimizedImage = React.createClass({
  displayName: 'OptimizedImage',
  propTypes: {
    alternateSrc: PropTypes.string,
    onLoad: PropTypes.func,
    imageClass: PropTypes.string,
    ratio: PropTypes.string,
    width: PropTypes.number,
    id: PropTypes.string,
    version: PropTypes.string,
    altText: PropTypes.string,
    title: PropTypes.string,
    preload: PropTypes.bool,
    optimizedLoaded: PropTypes.bool,
    source: PropTypes.string,
    imgixSettings: PropTypes.object
  },
  getInitialState() {
    return {
      useAlternateSrc: true
    };
  },
  _getSrc(source, ratio, width, id, version, imgixSettings) {
    //var isPlayPlaceholder = this.props.alternateSrc && this.props.alternateSrc.match && this.props.alternateSrc.match(/play_default_{image_versions.name}/);
    if (this.state.useAlternateSrc && this.props.alternateSrc) {
      return alternateImageServerUrl(this.props.alternateSrc, ratio, width);
    }
    return imageServerUrl({ratio, width, id, version, source, imgixSettings});
  },
  _onLoad() {
    this.props.onLoad();
  },
  _onError() {
    this.setState({
      useAlternateSrc: true
    });
  },
  render() {
    const {imageClass, ratio, width, id, version, altText, title, preload, optimizedLoaded, source, imgixSettings} = this.props;
    const src = this._getSrc(source, ratio, width, id, version, imgixSettings);
    var classObj = {
      'pic__img': true,
      'pic__img--optimized': true,
      'pic__img--loading': !preload && !optimizedLoaded
    };
    classObj['pic__img--' + ratio] = true;
    classObj[imageClass] = true;
    const classes = classSet(classObj);
    return (
      <img className={classes}
        src={src}
        alt={altText}
        title={title}
        onLoad={this._onLoad}
        onError={this._onError}
      />
    );
  }
});

export default OptimizedImage;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/_OptimizedImage.js
 **/